import { Button } from "components/common/button/Button";
import { useAtom } from "jotai"
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { stepAtom } from "store/signUpStore";
import './SignUpStep3.css'
import { OTPInput, OTPInputRef } from "components/common/input/OTPInput";
import { InputInfoMsg } from "components/common/input/Input";
import { Device } from "common/device";

export const SignUpStep3 = () => {
    const {t} = useTranslation();
    const [step, setStep] = useAtom(stepAtom);
    const otpRef = useRef<OTPInputRef>(null);
    const [otp, setOtp] = useState("");
    const [otpInfoMsg, setOtpInfoMsg] = useState<InputInfoMsg>();
    const [isBtnDisabled, setIsBtnDisabled] = useState(true);

    useEffect(() => {
        if(step === 3) {
            otpRef.current?.startCountDown();
        }
    },[step])

    return (
        <div className="sign-up-step-3" style={{display: step === 3 ? "block" : "none"}}>

            <OTPInput
                ref={otpRef}
                inputVal={otp}
                time={5}
                resendTime={2}
                onStart={() => {
                    console.log("start");
                }}
                onChange={(e) => {
                    // TOBE : 인증번호 체크 로직 추가
                    if(e.target.value.trim().length <= 0) {
                        setOtpInfoMsg(undefined);
                    } else if (e.target.value.trim().length === 6 && e.target.value.trim() === "111110") {
                        setOtpInfoMsg({type: "error", msg: t("signUp.otpErrorMsg")});
                        setIsBtnDisabled(true);
                    } else if (e.target.value.trim().length === 6) {
                        setOtpInfoMsg({type: "passed", msg: t("signUp.otpPassedMsg")});
                        setIsBtnDisabled(false);
                    }
                }}
                setInputVal={setOtp}
                infoMsg={otpInfoMsg}
            />

            <div style={{position: 'fixed', bottom: Device.inset.navigationBarHeight, width: '100%', left: 0, padding: "0 20px 20px"}}>
                <Button
                    text={t("signUp.btnAuthCom")}
                    disabled={isBtnDisabled}
                    onPress={() => {
                        // TOBE : 인증번호 체크 로직 추가
                        setStep(4);
                    }}
                />
            </div>
        </div>
    )
}